import { takeLatest, put } from 'redux-saga/effects';
import { fetchTransactionEvents, appNotify, setIsFetchingTransactionEvents } from 'store/actions';
import { getWithToken } from 'api/network';

export function* getTransactionEventsSaga() {
  yield takeLatest(fetchTransactionEvents, function* ({ payload }) {
    const { asgPropId, livingAreaSqFt, callback } = payload;
    try {
      yield put(setIsFetchingTransactionEvents(true));
      let queryUrl = `/api/explore/GetEventHistory?asgPropID=${asgPropId}`;
      if (livingAreaSqFt != null) {
        queryUrl = queryUrl + `&LivingAreaSqFt=${livingAreaSqFt}`;
      } 
      const res = yield getWithToken(queryUrl);
      const response = yield res.json();
      //yield delay(1000); // sleep to allow overlay to show up

      if (response.success) {
        // event history found
        if (callback) yield callback(response.data);
      }
      else {
        // event history not found
        if (callback) yield callback([]); // return empty history events []
      }
    } catch (error) {
      console.log('error', error.message);
      yield put(setIsFetchingTransactionEvents(false));
      yield put(appNotify(error.message, 'error'));
    }
    finally {
      yield put(setIsFetchingTransactionEvents(false));
    }
  });
}